import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Search, Header } from 'semantic-ui-react';
import i18next from 'i18next';
import { formatPrice } from '../../../helpers/format';
import { getBusinessCurrency } from '../../../selectors';

const resultRenderer = ({ item, title, currencyCode }) => {
    if (!item) {
        return title;
    }

    return (
        <Header.Content>
            {item.name}
            <Header.Subheader>
                {`${formatPrice(item.price, currencyCode)}  |  ${item.posItemId}  |  ${item.key}`}
            </Header.Subheader>
        </Header.Content>
    );
};

class SetMenuItem extends Component {
    state = {};

    componentDidMount() {
        this.resetComponent();
    }

    resetComponent = () => this.setState({ isLoading: false, results: [], value: '' })

    handleResultSelect = (e, { result }) => {
        if (!result.item) {
            this.props.onNewSelected(this.state.value);
        } else {
            this.props.onItemSelected(result.item);
        }

        this.resetComponent();
    }

    handleSearchChange = (e, { value }) => {
        this.setState({ isLoading: true, value });
        const { currencyCode } = this.props;

        setTimeout(() => {
            if (this.state.value.length < 1) return this.resetComponent();

            const re = new RegExp(_.escapeRegExp(this.state.value), 'i');
            const isMatch = result => re.test(result.name) || re.test(result.key) || re.test(result.posItemId);
            const results = _.filter(this.props.items, isMatch).map(item => ({ item, title: item.id, currencyCode }));
            results.push({ item: null, title: i18next.t('menu.createItem') });

            this.setState({
                isLoading: false,
                results,
            });
        }, 300);
    }

    render() {
        const { isLoading, value, results } = this.state;

        return (
            <Search
                loading={isLoading}
                onResultSelect={this.handleResultSelect}
                onSearchChange={_.debounce(this.handleSearchChange, 500, { leading: true })}
                results={results}
                value={value}
                resultRenderer={resultRenderer}
                placeholder={i18next.t('menu.setItem')}
                noResultsMessage=""
                fluid
            // {...this.props}
            />
        );
    }
}

SetMenuItem.propTypes = {
    onNewSelected: PropTypes.func.isRequired,
    onItemSelected: PropTypes.func.isRequired,
    currencyCode: PropTypes.string,
};

function mapStateToProps(state) {
    const items = Object.values(state.businessApp.menu.items);
    const currencyCode = getBusinessCurrency(state);

    return { items, currencyCode };
}

export default connect(mapStateToProps)(SetMenuItem);
